// src/constants/locations.js
// Refactored: Moved and enhanced from existing locations.js. Now exports cities as array of objects, regions as object with arrays of objects. Kept getLocationDisplay helper.

export const cities = [
  { value: 'Cairo', ar: 'القاهرة', en: 'Cairo' },
  { value: 'Giza', ar: 'الجيزة', en: 'Giza' },
  // To add a new city, e.g., Alexandria: { value: 'Alexandria', ar: 'الإسكندرية', en: 'Alexandria' }
];

export const regions = {
  Cairo: [
    { value: '15 May City', ar: '١٥ مايو', en: '15 May City' },
    { value: 'Abasiya', ar: 'العباسية', en: 'Abasiya' },
    { value: 'Abdeen', ar: 'عابدين', en: 'Abdeen' },
    { value: 'Ain Shams', ar: 'عين شمس', en: 'Ain Shams' },
    { value: 'Al Amiriyyah', ar: 'الأميرية', en: 'Al Amiriyyah' },
    { value: 'Al Manial', ar: 'المنيل', en: 'Al Manial' },
    { value: 'Almazah', ar: 'ألماظة', en: 'Almazah' },
    { value: 'Ataba', ar: 'العتبة', en: 'Ataba' },
    { value: 'Bab al-Shereia', ar: 'باب الشعرية', en: 'Bab al-Shereia' },
    { value: 'Bab El louk', ar: 'باب اللوق', en: 'Bab El louk' },
    { value: 'Badr City', ar: 'مدينة بدر', en: 'Badr City' },
    { value: 'Basateen', ar: 'البساتين', en: 'Basateen' },
    { value: 'Boulaq Abo El Ela', ar: 'بولاق أبو العلا', en: 'Boulaq Abo El Ela' },
    { value: 'Cairo - Ismailia Desert Road', ar: 'طريق القاهرة الإسماعيلية الصحراوي', en: 'Cairo - Ismailia Desert Road' },
    { value: 'Dar al-Salaam', ar: 'دار السلام', en: 'Dar al-Salaam' },
    { value: 'Darb al-Ahmar', ar: 'الدرب الأحمر', en: 'Darb al-Ahmar' },
    { value: 'Darrasa', ar: 'الدراسة', en: 'Darrasa' },
    { value: 'Downtown Cairo', ar: 'وسط البلد', en: 'Downtown Cairo' },
    { value: 'El Fostat', ar: 'الفسطاط', en: 'El Fostat' },
    { value: 'El Khalifa', ar: 'الخليفة', en: 'El Khalifa' },
    { value: 'El Zaher', ar: 'الظاهر', en: 'El Zaher' },
    { value: 'Ezbet El Nakhl', ar: 'عزبة النخل', en: 'Ezbet El Nakhl' },
    { value: 'Gamaleya', ar: 'الجمالية', en: 'Gamaleya' },
    { value: 'Garden City', ar: 'جاردن سيتي', en: 'Garden City' },
    { value: 'Gesr Al Suez', ar: 'جسر السويس', en: 'Gesr Al Suez' },
    { value: 'Ghamra', ar: 'غمرة', en: 'Ghamra' },
    { value: 'Hadayek al-Kobba', ar: 'حدائق القبة', en: 'Hadayek al-Kobba' },
    { value: 'Hadayek Helwan', ar: 'حدائق حلوان', en: 'Hadayek Helwan' },
    { value: 'Hadayeq El Zeitoun', ar: 'حدائق الزيتون', en: 'Hadayeq El Zeitoun' },
    { value: 'Heliopolis', ar: 'مصر الجديدة', en: 'Heliopolis' },
    { value: 'Helmeya al-Gadeda', ar: 'الحلمية الجديدة', en: 'Helmeya al-Gadeda' },
    { value: 'Helmeyat El Zaytoun', ar: 'حلمية الزيتون', en: 'Helmeyat El Zaytoun' },
    { value: 'Helwan', ar: 'حلوان', en: 'Helwan' },
    { value: 'Katameya', ar: 'القطامية', en: 'Katameya' },
    { value: 'Ma\'sara', ar: 'المعصرة', en: 'Ma\'sara' },
    { value: 'Maadi', ar: 'المعادي', en: 'Maadi' },
    { value: 'Maadi Degla', ar: 'دجلة المعادي', en: 'Maadi Degla' },
    { value: 'Madinaty', ar: 'مدينتي', en: 'Madinaty' },
    { value: 'Marg', ar: 'المرج', en: 'Marg' },
    { value: 'Masr al-Kadema', ar: 'مصر القديمة', en: 'Masr al-Kadema' },
    { value: 'Matareya', ar: 'المطرية', en: 'Matareya' },
    { value: 'Mokattam', ar: 'المقطم', en: 'Mokattam' },
    { value: 'Moski', ar: 'الموسكي', en: 'Moski' },
    { value: 'Mostakbal City', ar: 'مدينة المستقبل', en: 'Mostakbal City' },
    { value: 'Nasr City', ar: 'مدينة نصر', en: 'Nasr City' },
    { value: 'New Cairo', ar: 'القاهرة الجديدة', en: 'New Cairo' },
    { value: 'New Capital City', ar: 'العاصمة الإدارية الجديدة', en: 'New Capital City' },
    { value: 'New Heliopolis', ar: 'هليوبوليس الجديدة', en: 'New Heliopolis' },
    { value: 'New Nozha', ar: 'النزهة الجديدة', en: 'New Nozha' },
    { value: 'Nozha', ar: 'النزهة', en: 'Nozha' },
    { value: 'Obour City', ar: 'مدينة العبور', en: 'Obour City' },
    { value: 'Qasr al-Nil', ar: 'قصر النيل', en: 'Qasr al-Nil' },
    { value: 'Ramses + Ramses Extension', ar: 'رمسيس وامتداد رمسيس', en: 'Ramses + Ramses Extension' },
    { value: 'Rod al-Farag', ar: 'روض الفرج', en: 'Rod al-Farag' },
    { value: 'Salam City', ar: 'مدينة السلام', en: 'Salam City' },
    { value: 'Sayeda Zeinab', ar: 'السيدة زينب', en: 'Sayeda Zeinab' },
    { value: 'Sharabeya', ar: 'الشرابية', en: 'Sharabeya' },
    { value: 'Sheraton', ar: 'شيراتون', en: 'Sheraton' },
    { value: 'Shorouk City', ar: 'مدينة الشروق', en: 'Shorouk City' },
    { value: 'Shubra', ar: 'شبرا', en: 'Shubra' },
    { value: 'Tebeen', ar: 'التبين', en: 'Tebeen' },
    { value: 'Tura', ar: 'طرة', en: 'Tura' },
    { value: 'Waili', ar: 'الوايلي', en: 'Waili' },
    { value: 'Zahraa Al Maadi', ar: 'زهراء المعادي', en: 'Zahraa Al Maadi' },
    { value: 'Zamalek', ar: 'الزمالك', en: 'Zamalek' },
    { value: 'Zawya al-Hamra', ar: 'الزاوية الحمراء', en: 'Zawya al-Hamra' }
  ],
  Giza: [
    { value: '6th of October', ar: 'السادس من أكتوبر', en: '6th of October' },
    { value: 'Abou Al Nomros', ar: 'أبو النمرس', en: 'Abou Al Nomros' },
    { value: 'Abu Rawash', ar: 'أبو رواش', en: 'Abu Rawash' },
    { value: 'Agouza', ar: 'العجوزة', en: 'Agouza' },
    { value: 'Al Omraneyah', ar: 'العمرانية', en: 'Al Omraneyah' },
    { value: 'Al Wahat Al Baharia', ar: 'الواحات البحرية', en: 'Al Wahat Al Baharia' },
    { value: 'Ard El Lewa', ar: 'أرض اللواء', en: 'Ard El Lewa' },
    { value: 'Atfih', ar: 'أطفيح', en: 'Atfih' },
    { value: 'Badrasheen', ar: 'البدرشين', en: 'Badrasheen' },
    { value: 'Baragil', ar: 'البراجيل', en: 'Baragil' },
    { value: 'Bashtil', ar: 'بشتيل', en: 'Bashtil' },
    { value: 'Boulaq Dakrour', ar: 'بولاق الدكرور', en: 'Boulaq Dakrour' },
    { value: 'Dahab Island', ar: 'جزيرة الذهب', en: 'Dahab Island' },
    { value: 'Dahshur', ar: 'دهشور', en: 'Dahshur' },
    { value: 'Dokki', ar: 'الدقي', en: 'Dokki' },
    { value: 'El Ayyat', ar: 'العياط', en: 'El Ayyat' },
    { value: 'Faisal', ar: 'فيصل', en: 'Faisal' },
    { value: 'Giza District', ar: 'حي الجيزة', en: 'Giza District' },
    { value: 'Hadayek al-Ahram', ar: 'حدائق الأهرام', en: 'Hadayek al-Ahram' },
    { value: 'Hadayek October', ar: 'حدائق أكتوبر', en: 'Hadayek October' },
    { value: 'Haram', ar: 'الهرم', en: 'Haram' },
    { value: 'Hawamdeya', ar: 'الحوامدية', en: 'Hawamdeya' },
    { value: 'Imbaba', ar: 'إمبابة', en: 'Imbaba' },
    { value: 'Kerdasa', ar: 'كرداسة', en: 'Kerdasa' },
    { value: 'Kit Kat', ar: 'الكيت كات', en: 'Kit Kat' },
    { value: 'Manial Shiha', ar: 'منيل شيحة', en: 'Manial Shiha' },
    { value: 'Mansuriyya', ar: 'المنصورية', en: 'Mansuriyya' },
    { value: 'Markaz al-Giza', ar: 'مركز الجيزة', en: 'Markaz al-Giza' },
    { value: 'Maryotaya', ar: 'المريوطية', en: 'Maryotaya' },
    { value: 'Meet Okba', ar: 'ميت عقبة', en: 'Meet Okba' },
    { value: 'Mohandessin', ar: 'المهندسين', en: 'Mohandessin' },
    { value: 'Moneeb', ar: 'المنيب', en: 'Moneeb' },
    { value: 'Nahia', ar: 'ناهيا', en: 'Nahia' },
    { value: 'Oseem', ar: 'أوسيم', en: 'Oseem' },
    { value: 'Rabea El Gizy St.', ar: 'شارع ربيع الجيزي', en: 'Rabea El Gizy St.' },
    { value: 'Saf', ar: 'الصف', en: 'Saf' },
    { value: 'Saft El Laban', ar: 'صفط اللبن', en: 'Saft El Laban' },
    { value: 'Sakiat Mekki', ar: 'ساقية مكي', en: 'Sakiat Mekki' },
    { value: 'Sakkara', ar: 'سقارة', en: 'Sakkara' },
    { value: 'Sheikh Zayed', ar: 'الشيخ زايد', en: 'Sheikh Zayed' },
    { value: 'Tersa', ar: 'ترسا', en: 'Tersa' },
    { value: 'Warraq', ar: 'الوراق', en: 'Warraq' }
  ],
  // For new city Alexandria: Alexandria: [{ value: 'Montaza', ar: 'المنتزه', en: 'Montaza' }, ...]
};

export const getLocationDisplay = (city, region, language) => {
  const cityObj = cities.find(c => c.value === city);
  const regionObj = regions[city]?.find(r => r.value === region);
  const cityText = language === 'ar' ? (cityObj?.ar || city) : (cityObj?.en || city);
  const regionText = language === 'ar' ? (regionObj?.ar || region) : (regionObj?.en || region);
  return regionText ? `${cityText} - ${regionText}` : cityText;
};